function getCookie(name: string) {
  return document.cookie
    .split(';')
    .map((s) => s.trim().split('='))
    .find((kv) => kv[0] === name)?.[1];
}

function getUserCookie() {
  const userCookie = getCookie('user');

  if (!userCookie) {
    window.location.assign(process.env.UNAUTHORIZED_REDIRECT_URL);
  }

  // 存在しない場合はエラーページに遷移させるので問題ない
  return JSON.parse(decodeURIComponent(userCookie!)) as {
    company_code?: string;
  };
}

function hasSandboxToken() {
  return getCookie('sandbox_token');
}

export { getUserCookie, hasSandboxToken };
